export default {
    getList: {
        getPendList: async function (params) {
            let option = {
                url: '/api/v1/partner/sites',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminSiteManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getProvinces: async function (params) {
            let option = {
                url: '/api/v1/common/provinces',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminSiteManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getDistricts: async function (params) {
            let option = {
                url: '/api/v1/common/districts',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminSiteManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getCity: async function (params) {
            let option = {
                url: '/api/v1/common/citys',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminSiteManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        resetKey: async function (params) {
            let option = {
                url: '/api/v1/partner/site/' + params.sn,
                type: 'patch',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminSiteManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        }
    },
    do: {
        newSite: async function (params) {
            let option = {
                url: '/api/v1/partner/site',
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminSiteManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        editorSite: async function (params) {
            let option = {
                url: '/api/v1/partner/site/' + params.id,
                type: 'putFile',
                params: params.form,
                mock: {
                    state: false,
                    data: this.$mock.adminSiteManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        deleteSite: async function (params) {
            let option = {
                url: '/api/v1/partner/site/' + params.sn,
                type: 'delete',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminSiteManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        siteLicence: async function (params) {
            let option = {
                url: '/api/v1/partner/site/licence/' + params.site_id,
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminSiteManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        }
    },
}
